import type { ApiClient } from "../../auth/apiClient";
import { WorkflowTimelineResponseSchema } from "./types";
import type { WorkflowTimelineResponse } from "./types";

export async function fetchWorkflowTimeline(
    client: ApiClient,
    workflowId: string,
    entityType: string,
    entityId: string,
): Promise<WorkflowTimelineResponse> {
    const params = new URLSearchParams({ entityType, entityId });
    const response = await client.fetch(
        `/workflows/${encodeURIComponent(workflowId)}/timeline?${params.toString()}`,
    );

    // 503 is part of the contract for "every upstream ledger stream
    // failed" — treat it as a hard error here so React Query surfaces
    // an error state the UI can disclose. Partial-but-non-empty
    // responses come back as 200 with `partial: true` and parse cleanly.
    if (!response.ok) {
        throw new Error(
            `Failed to fetch timeline for workflow ${workflowId}: ${String(response.status)} ${response.statusText}`,
        );
    }

    const json: unknown = await response.json();
    return WorkflowTimelineResponseSchema.parse(json);
}
